import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { history } from '../../_helpers';
import { Form, Input, Button, Divider, Grid } from 'semantic-ui-react';
import { authAPI } from '../../_services';

export const CustomerLogin = ({
  activateCustomer = null,
  activateToken = null,
  location = null
}) => {
  const dispatch = useDispatch();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errored, setErrored] = useState('');

  const validate = (email, password, confirmPassword) => {
    if (!email) return 'Email address required';
    if (!password) return 'Password required';
    if (activateCustomer && password !== confirmPassword)
      return 'Passwords must match';
    return false;
  };

  const login = () => {
    if (!activateCustomer) {
      const error = validate(email, password, confirmPassword);
      if (error) {
        setErrored(error);
        return;
      }
    }

    if (activateCustomer && activateToken) {
      let values = {
        email: email,
        password: password
      };

      authAPI.activate(activateCustomer, activateToken, values).then(
        response => {
          authAPI.loginPassword(email, password, null, location, dispatch).then(
            response => setErrored(false),
            error => setErrored(error)
          );
        },
        error => {
          setErrored(error);
        }
      );
    } else {
      authAPI.loginPassword(email, password, null, location, dispatch).then(
        response => setErrored(false),
        error => setErrored(error)
      );
    }
  };

  const onBlur = () => {
    const error = validate(email, password, confirmPassword);
    setErrored(error);
  };

  return (
    <React.Fragment>
      {activateCustomer && (
        <>
          Please choose a password and login to activate your account!
          <br />
          <br />
        </>
      )}
      <Form>
        <div>
          <Form.Field>
            <label>EMAIL</label>
            <Input
              error={!!errored}
              value={email}
              width={6}
              icon="user"
              iconPosition="left"
              name="email"
              onBlur={onBlur}
              onChange={(_, { value }) => {
                setEmail(value);
              }}
            />
          </Form.Field>
          <Form.Field style={{ position: 'relative' }}>
            <label>PASSWORD</label>
            <Input
              error={!!errored}
              value={password}
              type={showPassword ? 'text' : 'password'}
              width={6}
              icon="lock"
              iconPosition="left"
              name="password"
              onBlur={onBlur}
              onChange={(_, { value }) => {
                setPassword(value);
                setErrored(validate(email, value, confirmPassword));
              }}
            />
            <span
              style={{
                position: 'absolute',
                top: '50%',
                right: '10px',
                transform: 'translateY(10%)',
                cursor: 'pointer'
              }}
              onClick={() => {
                setShowPassword(!showPassword);
              }}
            >
              <i class="fas fa-eye"></i>
            </span>
          </Form.Field>
          {activateCustomer && (
            <Form.Field>
              <label>CONFIRM PASSWORD</label>
              <Input
                error={!!errored}
                value={confirmPassword}
                type={showPassword ? 'text' : 'password'}
                width={6}
                icon="lock"
                iconPosition="left"
                name="confirmPassword"
                onBlur={onBlur}
                onChange={(_, { value }) => {
                  setConfirmPassword(value);
                  setErrored(validate(email, password, value));
                }}
              />
            </Form.Field>
          )}
          {errored && (
            <React.Fragment>
              <label>{errored}</label>
              <br />
              <br />
            </React.Fragment>
          )}
        </div>
        <br />
        <br />
        <Button
          style={{
            width: '100%'
          }}
          color="olive"
          onClick={event => {
            event.preventDefault();
            login();
          }}
          disabled={activateCustomer && password !== confirmPassword}
        >
          LOGIN
        </Button>
        {!activateCustomer && (
          <>
            <Divider />
            <Grid centered padded textAlign="center">
              <Button
                style={{
                  width: '40%',
                  textAlign: 'center'
                }}
                size="tiny"
                color="olive"
                onClick={event => {
                  history.push('/forgotPassword');
                }}
              >
                Forgot password?
              </Button>
            </Grid>
          </>
        )}
      </Form>
    </React.Fragment>
  );
};
